// extracted by mini-css-extract-plugin
export default {"actions":"ActivityRow-module__actions--AuE0J","box":"ActivityRow-module__box--KdkSi"};